import { gql } from "graphql-request";

export const BILLING_NOTE_BY_ITEM_REPORT = gql`
  query BillingNoteByItemReportViewsAggrid($aggridInput: AnyAggridInput) {
    BillingNoteByItemReportViewsAggrid(aggridInput: $aggridInput) {
      count
      results {
        item_unique_id
        item_name
        qty
        uom_name
        net_amount
        pre_vat_amount
        vat_amount
      }
    }
  }
`;

export const BILLING_NOTE_BY_CUSTOMER_REPORT = gql`
  query BillingNoteByCustomerReportViewsAggrid($aggridInput: AnyAggridInput) {
    BillingNoteByCustomerReportViewsAggrid(aggridInput: $aggridInput) {
      count
      results {
        customer_unique_id
        customer_name
        dt_document_amount
        income_net_amount
        income_pre_vat_amount
        income_vat_amount
      }
    }
  }
`;

export const BILLING_NOTE_BY_DELIVERY_ITEM_REPORT = gql`
  query BillingNoteByDeliveryItemReportViewsAggrid(
    $aggridInput: AnyAggridInput
  ) {
    BillingNoteByDeliveryItemReportViewsAggrid(aggridInput: $aggridInput) {
      results {
        unique_id
        aggrid_status
        company_type
        created_date
        issue_date
        due_date
        credit_day
        related_user_list
        customer_unique_id
        customer_name
        tax_id
        phone
        email
        fax
        billing_address
        dt_index
        income_unique_id
        dt_unique_id
        job_no
        dt_issue_date
        dt_vehicle_license_plate
        dt_vehicle_type
        dt_fuel_price
        income_item_unique_id
        income_item_name
        income_item_pre_vat_amount
        description
        pre_discount_amount
        discount
        discount_type
        discount_thb
        post_discount_amount
        vat_type
        vat_amount
        net_amount
        withholding_tax_percent
        withholding_tax_amount
        total_amount
        remark
      }
      count
    }
  }
`;
